import React, { useEffect, useState } from "react";
import "../../Assets/css/paymentOptions.css";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {
  Box,
  Card,
  CardContent,
  Container,
  Grid,
  Slide,
  Snackbar,
  Typography,
} from "@mui/material";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import Axios from "axios";
import MuiAlert from "@mui/material/Alert";
import Swal from "sweetalert2";
import LoadingStatus from "../../Components/PolicyStatusComponents/LoadingStatus";
import { getLocalData } from "../../Utilities/Common/source";
import axiosInstance from "../../Utilities/djangoAxiosInstance";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function TransitionLeft(props) {
  return <Slide {...props} direction="left" />;
}

const HdfcErgoPolicyStatus = () => {
  const location = useLocation();
  const { referencetId } = useParams();
  const referencetIdArray = referencetId.split("*");
  //const refID = referencetIdArray[0]
  //const goldManId = referencetIdArray[1]
  const [responseData, setResponseData] = useState({});
  const [sendSMS, setSendSMS] = useState(false);
  const [msgForSMSButton, setMsgForSMSButton] = useState(
    "Send Download link to customer"
  );
  const navigate = useNavigate();
  const localSource = getLocalData("source");
  console.log("HDFC PolicyStatus localSource: ", localSource);
  console.log("responseData", responseData);
  //62e28fc7150e9c6a0a39676e
  useEffect(() => {
    let domain = "";

    axiosInstance.get(`api/health/createquote-response/${referencetId}/`, {
      params: {
        source: localSource,
      },
    }).then((response) => {
      console.log("respon", response);
      setResponseData(response.data.response);
    }).catch((err)=>{
      console.error("Error while fetching pdf:",err,err?.response?.data?.error_occured?.Error)
      alert(err?.response?.data?.error_occured?.Error ?? "Something went wrong in pdf generation !")
    });
  }, []);

  const backButtonHandler = () => {
    navigate(-1);
  };

  const sendLink = async () => {
    await Axios.get(
      `https://dev.acuvisor.com/V2/AcuHealthInsurance/health_policy_payment_link?enquiryId=${responseData.A_id}&referenceId=${referencetId}`
    ).then((response) => {
      //console.log('fffss', response)
      if (response.data.status) {
        setSendSMS(true);
        setMsgForSMSButton("A sms will be sent to the Customer");
      }
      console.log("data", response.data);
    });
  };

  const handleCloseSlack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setSendSMS(false);
  };

  function downloadPDF(pdf) {
    const linkSource = `data:application/pdf;base64,${pdf}`;
    const downloadLink = document.createElement("a");
    const fileName =
      responseData.policy_name + responseData.Policy_Number + ".pdf";

    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  const downloadHere = () => {
    //console.log('link', responseData.proposalNum)
    let pdfBytes = { pdf_data: responseData.Resp_Policy_Document.PDF_BYTES };
    console.log("pdfBytes", pdfBytes);
    console.log("statusCode", responseData.StatusCode);

    downloadPDF(responseData.Resp_Policy_Document.PDF_BYTES);
    if (responseData.StatusCode === 200) {
      Swal.fire({
        icon: "success",
        // title: `${response.data.data.iskycVerified}`,
        title: "Your Policy is Downloaded",
        text: "Click on Next button to proceed",
        text: `Your Policy No. is: ${responseData.Policy_Number} `,
        position: "center",

        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          let path = `/health-insurance/thankyou`;
          navigate(path);
        }
      });
    }
  };

  return (
    <>
      {responseData?.policyStatus === 5 ? (
        <LoadingStatus
          status={5}
          data={""}
          proposerNum={responseData.proposalNumber}
        />
      ) : (
        <div>
          <div className="header-section">
            <p className="insurence-title-sec">
              Health Insurance
              <KeyboardArrowDownIcon />
            </p>
          </div>

          <Container
            style={{ marginTop: 10, marginBottom: 10 }}
            maxWidth="sm md lg"
          >
            <Card className="card-section" sx={{ minWidth: 275, marginTop: 5 }}>
              <Box sx={{ display: "flex", marginBottom: 4 }}>
                <img
                  className="bg-white img-thumbnail rounded"
                  width={100}
                  height={100}
                  src={responseData?.logo}
                />
                <Box style={{ margin: 16 }}>
                  <Typography>{responseData?.vendor}</Typography>
                  <Typography>{responseData?.policy_name}</Typography>
                </Box>
              </Box>
              <CardContent>
                <Grid container spacing={2}>
                  <Grid item xs={5}>
                    <Typography>Proposer Name:</Typography>
                  </Grid>
                  <Grid item xs={7}>
                    <Typography>
                      <strong>{responseData?.proposer_name}</strong>
                    </Typography>
                  </Grid>
                  <Grid item xs={5}>
                    <Typography>Policy Type:</Typography>
                  </Grid>
                  <Grid item xs={7}>
                    <Typography>
                      <strong>
                        {responseData?.number_of_insured > 1
                          ? "Floater"
                          : "Individual"}
                      </strong>
                    </Typography>
                  </Grid>
                  <Grid item xs={5}>
                    <Typography>Number of Insured(s):</Typography>
                  </Grid>
                  <Grid item xs={7}>
                    <Typography>{responseData?.number_of_insured} </Typography>
                  </Grid>
                  <Grid item xs={5}>
                    <Typography>Policy Number:</Typography>
                  </Grid>
                  <Grid item xs={7}>
                    <Typography>{responseData?.Policy_Number} </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography></Typography>
                  </Grid>
                  <hr />
                  <Grid item xs={3}></Grid>
                </Grid>
              </CardContent>
            </Card>

            <div className="button-section">
              <div>
                <Snackbar
                  open={sendSMS}
                  anchorOrigin={{ vertical: "top", horizontal: "right" }}
                  autoHideDuration={5000}
                  TransitionComponent={TransitionLeft}
                  onClose={handleCloseSlack}
                >
                  <Alert severity="success" onClose={handleCloseSlack}>
                    A sms will be sent to the customer
                  </Alert>
                </Snackbar>
              </div>
              <div>
                <button
                  className="pay-btn "
                  type="button"
                  onClick={downloadHere}
                >
                  Download Policy
                </button>
              </div>
              {/* <div>
                <button
                  className="back-btn"
                  type="button"
                  onClick={backButtonHandler}
                >
                  Back
                </button>
              </div> */}
            </div>
          </Container>
        </div>
      )}
    </>
  );
};

export default HdfcErgoPolicyStatus;
